import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { DEFAULT_MENU_WIDTH, MENU_MAX_HEIGHT } from '../constants.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MenuContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: DEFAULT_MENU_WIDTH,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxHeight: MENU_MAX_HEIGHT,
	paddingTop: token('space.050'),
	paddingRight: '0px',
	paddingBottom: token('space.050'),
	paddingLeft: '0px',
	borderRadius: 3,
	boxSizing: 'border-box',

	backgroundColor: token('elevation.surface.overlay'),
});
